const AppTitle = function (text) {
    return text + (text ? " - " : "") + "L&T Hub";
};

export default AppTitle;